// types
import { ResourceResponse } from 'generated/index';

// hooks
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSaveResource } from './ResourceForm.hooks';

// utils
import schema from '../../Resources.schema';
import { yupResolver } from '@hookform/resolvers/yup';
import { isUniqueResourceCode } from '../../Resources.utils';

// components
import { LoadingButton } from '@mui/lab';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';
import { BaseResourceSection } from '../BaseResourceSection/BaseResourceSection';
import { ResourceFormProps } from './ResourceForm.types';

export const ResourceForm = ({
  rowData,
  handleClose,
  rows
}: ResourceFormProps) => {
  const { t } = useTranslation('common');

  const methods = useForm<any>({
    defaultValues: schema.cast(rowData),
    resolver: yupResolver(schema)
  });

  const { mutate, isLoading } = useSaveResource({
    onSuccess: handleClose
  });

  const { control, handleSubmit } = methods;

  const onSubmit = (data: ResourceResponse) => {
    if (!isUniqueResourceCode(data?.code, rowData?.code, rows)) {
      return methods.setError('code', {
        type: 'manual',
        message: t('validation.unique', {
          name: t('adminPortal.resources.code')
        })
      });
    }

    mutate(data);
  };

  return (
    <MultiStepForm onSubmit={handleSubmit(onSubmit)} methods={methods}>
      <BaseResourceSection control={control} />
      <MultiStepForm.Actions>
        <LoadingButton
          loading={isLoading}
          type="submit"
          variant="contained"
          autoFocus
          color="primary"
          fullWidth
        >
          {t('save')}
        </LoadingButton>
      </MultiStepForm.Actions>
    </MultiStepForm>
  );
};
